import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import parser, { Tag } from 'bbcode-to-react';

// Rich Text components
import ImageText from './ImageText';
import ImageCentered from './ImageCentered';
import ListChecked from './ListChecked';
import ListUnOrdered from './ListUnOrdered';
import ListOrdered from './ListOrdered';
import ListItem from './ListItem';
import PageLinkInternal from './PageLinkInternal';
import PageLinkExternal from './PageLinkExternal';
import Heading2 from './Heading2';
import Heading3 from './Heading3';
import Heading4 from './Heading4';
import Paragraph from './Paragraph';
import Quote from './Quote';
import ButtonDownload from '../buttons/ButtonDownload';
import ButtonSecondary from '../buttons/ButtonSecondary';
import ButtonPrimary from '../buttons/ButtonPrimary';
import Video from './Video';
import { CloseModalComponent } from '../../organisms/BBCodeHandler';
var BBCode = /*#__PURE__*/function (_React$Component) {
  function BBCode() {
    _classCallCheck(this, BBCode);
    return _callSuper(this, BBCode, arguments);
  }
  _inherits(BBCode, _React$Component);
  return _createClass(BBCode, [{
    key: "render",
    value: function render() {
      if (!this.props.content.content) return null;
      var elements = this.applyPropsToEls(parser.toReact(this.props.content.content), this.props);
      return __jsx("div", {
        "data-id": "richText_BBCode_div"
      }, elements);
    }
  }, {
    key: "applyPropsToEls",
    value: function applyPropsToEls(elem, props) {
      var _this = this;
      return React.Children.map(elem, function (el) {
        if (!el || !el.type) {
          return el;
        }
        var newProps;
        switch (el.props.elType) {
          case 'ImageCentered':
          case 'ImageText':
            newProps = {
              media: props.content.media
            };
            break;
          case 'ButtonDownload':
            newProps = {
              files: props.content.files
            };
            break;
          case 'PageLinkInternal':
            newProps = {
              pages: props.content.pages
            };
            break;
          default:
            break;
        }
        return /*#__PURE__*/React.cloneElement(el, newProps, el.props.children ? _this.applyPropsToEls(el.props.children, props) : null);
      });
    }
  }]);
}(React.Component); // Default HTML tags
export { BBCode as default };
var BrTag = /*#__PURE__*/function (_Tag) {
  function BrTag() {
    _classCallCheck(this, BrTag);
    return _callSuper(this, BrTag, arguments);
  }
  _inherits(BrTag, _Tag);
  return _createClass(BrTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx("br", {
        "data-id": "richText_BBCode_br"
      });
    }
  }]);
}(Tag);
var BoldTag = /*#__PURE__*/function (_Tag2) {
  function BoldTag() {
    _classCallCheck(this, BoldTag);
    return _callSuper(this, BoldTag, arguments);
  }
  _inherits(BoldTag, _Tag2);
  return _createClass(BoldTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx("strong", {
        "data-id": "richText_BBCode_strong"
      }, this.getComponents());
    }
  }]);
}(Tag); // Custom tags
var QuoteTag = /*#__PURE__*/function (_Tag3) {
  function QuoteTag() {
    _classCallCheck(this, QuoteTag);
    return _callSuper(this, QuoteTag, arguments);
  }
  _inherits(QuoteTag, _Tag3);
  return _createClass(QuoteTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(Quote, {
        "data-id": "richText_BBCode_Quote"
      }, this.getComponents());
    }
  }]);
}(Tag);
var ListItemTag = /*#__PURE__*/function (_Tag4) {
  function ListItemTag() {
    _classCallCheck(this, ListItemTag);
    return _callSuper(this, ListItemTag, arguments);
  }
  _inherits(ListItemTag, _Tag4);
  return _createClass(ListItemTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ListItem, {
        type: this.parent.name,
        "data-id": "richText_BBCode_ListItem"
      }, this.getComponents());
    }
  }]);
}(Tag);
var ParagraphTag = /*#__PURE__*/function (_Tag5) {
  function ParagraphTag() {
    _classCallCheck(this, ParagraphTag);
    return _callSuper(this, ParagraphTag, arguments);
  }
  _inherits(ParagraphTag, _Tag5);
  return _createClass(ParagraphTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(Paragraph, {
        "data-id": "richText_BBCode_Paragraph"
      }, this.getComponents());
    }
  }]);
}(Tag);
var DownloadButtonTag = /*#__PURE__*/function (_Tag6) {
  function DownloadButtonTag() {
    _classCallCheck(this, DownloadButtonTag);
    return _callSuper(this, DownloadButtonTag, arguments);
  }
  _inherits(DownloadButtonTag, _Tag6);
  return _createClass(DownloadButtonTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ButtonDownload, {
        elType: "ButtonDownload",
        fileId: this.params.file,
        content: this.getContent(),
        "data-id": "richText_BBCode_ButtonDownload"
      });
    }
  }]);
}(Tag);
var OrderedListTag = /*#__PURE__*/function (_Tag7) {
  function OrderedListTag() {
    _classCallCheck(this, OrderedListTag);
    return _callSuper(this, OrderedListTag, arguments);
  }
  _inherits(OrderedListTag, _Tag7);
  return _createClass(OrderedListTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ListOrdered, {
        "data-id": "richText_BBCode_ListOrdered"
      }, this.getComponents());
    }
  }]);
}(Tag);
var UnOrderedListTag = /*#__PURE__*/function (_Tag8) {
  function UnOrderedListTag() {
    _classCallCheck(this, UnOrderedListTag);
    return _callSuper(this, UnOrderedListTag, arguments);
  }
  _inherits(UnOrderedListTag, _Tag8);
  return _createClass(UnOrderedListTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ListUnOrdered, {
        "data-id": "richText_BBCode_ListUnOrdered"
      }, this.getComponents());
    }
  }]);
}(Tag);
var CheckListTag = /*#__PURE__*/function (_Tag9) {
  function CheckListTag() {
    _classCallCheck(this, CheckListTag);
    return _callSuper(this, CheckListTag, arguments);
  }
  _inherits(CheckListTag, _Tag9);
  return _createClass(CheckListTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ListChecked, {
        "data-id": "richText_BBCode_ListChecked"
      }, this.getComponents());
    }
  }]);
}(Tag);
var SecondaryButtonTag = /*#__PURE__*/function (_Tag0) {
  function SecondaryButtonTag() {
    _classCallCheck(this, SecondaryButtonTag);
    return _callSuper(this, SecondaryButtonTag, arguments);
  }
  _inherits(SecondaryButtonTag, _Tag0);
  return _createClass(SecondaryButtonTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ButtonSecondary, {
        type: "externalLink",
        link: this.params.href,
        target: this.params.target,
        label: this.getContent(),
        "data-id": "richText_BBCode_ButtonSecondary"
      });
    }
  }]);
}(Tag);
var PrimaryButtonTag = /*#__PURE__*/function (_Tag1) {
  function PrimaryButtonTag() {
    _classCallCheck(this, PrimaryButtonTag);
    return _callSuper(this, PrimaryButtonTag, arguments);
  }
  _inherits(PrimaryButtonTag, _Tag1);
  return _createClass(PrimaryButtonTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ButtonPrimary, {
        href: this.params.href,
        target: this.params.target,
        content: this.getContent(),
        "data-id": "richText_BBCode_ButtonPrimary"
      });
    }
  }]);
}(Tag);
var ImageTextTag = /*#__PURE__*/function (_Tag10) {
  function ImageTextTag() {
    _classCallCheck(this, ImageTextTag);
    return _callSuper(this, ImageTextTag, arguments);
  }
  _inherits(ImageTextTag, _Tag10);
  return _createClass(ImageTextTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ImageText, {
        elType: "ImageText",
        mediaId: this.params.media,
        alignment: this.params.alignment,
        imageAlt: this.params.alt,
        title: this.params.title,
        components: this.getComponents(),
        "data-id": "richText_BBCode_ImageText"
      });
    }
  }]);
}(Tag);
var ImageCenteredTag = /*#__PURE__*/function (_Tag11) {
  function ImageCenteredTag() {
    _classCallCheck(this, ImageCenteredTag);
    return _callSuper(this, ImageCenteredTag, arguments);
  }
  _inherits(ImageCenteredTag, _Tag11);
  return _createClass(ImageCenteredTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(ImageCentered, {
        elType: "ImageCentered",
        mediaId: this.params.media,
        alt: this.params.alt,
        caption: this.getContent(),
        "data-id": "richText_BBCode_ImageCentered"
      });
    }
  }]);
}(Tag);
var InternalLinkTag = /*#__PURE__*/function (_Tag12) {
  function InternalLinkTag() {
    _classCallCheck(this, InternalLinkTag);
    return _callSuper(this, InternalLinkTag, arguments);
  }
  _inherits(InternalLinkTag, _Tag12);
  return _createClass(InternalLinkTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(PageLinkInternal, _defineProperty(_defineProperty({
        elType: "PageLinkInternal",
        pageId: this.params.pagenode,
        type: this.params.type === 'skip' ? 'skip' : this.params.type,
        content: this.getContent(),
        pages: {}
      }, "pages", this.params.pagenode), "data-id", "richText_BBCode_PageLinkInternal"));
    }
  }]);
}(Tag);
var ExternalLinkTag = /*#__PURE__*/function (_Tag13) {
  function ExternalLinkTag() {
    _classCallCheck(this, ExternalLinkTag);
    return _callSuper(this, ExternalLinkTag, arguments);
  }
  _inherits(ExternalLinkTag, _Tag13);
  return _createClass(ExternalLinkTag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(PageLinkExternal, {
        link: this.params.href,
        type: this.params.type,
        content: this.getContent(),
        "data-id": "richText_BBCode_PageLinkExternal"
      });
    }
  }]);
}(Tag);
var Heading2Tag = /*#__PURE__*/function (_Tag14) {
  function Heading2Tag() {
    _classCallCheck(this, Heading2Tag);
    return _callSuper(this, Heading2Tag, arguments);
  }
  _inherits(Heading2Tag, _Tag14);
  return _createClass(Heading2Tag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(Heading2, {
        "data-id": "richText_BBCode_Heading2"
      }, this.getComponents());
    }
  }]);
}(Tag);
var Heading3Tag = /*#__PURE__*/function (_Tag15) {
  function Heading3Tag() {
    _classCallCheck(this, Heading3Tag);
    return _callSuper(this, Heading3Tag, arguments);
  }
  _inherits(Heading3Tag, _Tag15);
  return _createClass(Heading3Tag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(Heading3, {
        "data-id": "richText_BBCode_Heading3"
      }, this.getComponents());
    }
  }]);
}(Tag);
var Heading4Tag = /*#__PURE__*/function (_Tag16) {
  function Heading4Tag() {
    _classCallCheck(this, Heading4Tag);
    return _callSuper(this, Heading4Tag, arguments);
  }
  _inherits(Heading4Tag, _Tag16);
  return _createClass(Heading4Tag, [{
    key: "toReact",
    value: function toReact() {
      return __jsx(Heading4, {
        "data-id": "richText_BBCode_Heading4"
      }, this.getComponents());
    }
  }]);
}(Tag);
var YouTubeTag = /*#__PURE__*/function (_Tag17) {
  function YouTubeTag() {
    _classCallCheck(this, YouTubeTag);
    return _callSuper(this, YouTubeTag, arguments);
  }
  _inherits(YouTubeTag, _Tag17);
  return _createClass(YouTubeTag, [{
    key: "toReact",
    value: function toReact() {
      if (!this.getComponents()) {
        return null;
      }
      return __jsx(Video, {
        type: "youtube",
        id: this.getComponents()[0],
        "data-id": "richText_BBCode_Video"
      });
    }
  }]);
}(Tag);
var VimeoTag = /*#__PURE__*/function (_Tag18) {
  function VimeoTag() {
    _classCallCheck(this, VimeoTag);
    return _callSuper(this, VimeoTag, arguments);
  }
  _inherits(VimeoTag, _Tag18);
  return _createClass(VimeoTag, [{
    key: "toReact",
    value: function toReact() {
      if (!this.getComponents()) {
        return null;
      }
      return __jsx(Video, {
        type: "vimeo",
        id: this.getComponents()[0],
        "data-id": "richText_BBCode_Video_20"
      });
    }
  }]);
}(Tag);
var CloseModal = /*#__PURE__*/function (_Tag19) {
  function CloseModal() {
    _classCallCheck(this, CloseModal);
    return _callSuper(this, CloseModal, arguments);
  }
  _inherits(CloseModal, _Tag19);
  return _createClass(CloseModal, [{
    key: "toReact",
    value: function toReact() {
      if (!this.getContent() || !this.params) {
        return null;
      }
      return __jsx(CloseModalComponent, {
        content: this.getContent(),
        params: this.params,
        "data-id": "richText_BBCode_CloseModalComponent"
      });
    }
  }]);
}(Tag); // Please note: when using registerTag, the first argument must be all lowercase,
// otherwise the tag won't be recognized by the parser.
// Also see: https://github.com/JimLiu/bbcode-to-react/issues/11
parser.registerTag('quote', QuoteTag);
parser.registerTag('li', ListItemTag);
parser.registerTag('br', BrTag);
parser.registerTag('b', BoldTag);
parser.registerTag('strong', BoldTag);
parser.registerTag('p', ParagraphTag);
parser.registerTag('centeredimage', ImageCenteredTag);
parser.registerTag('imagetext', ImageTextTag);
parser.registerTag('olist', CheckListTag);
parser.registerTag('ol', OrderedListTag);
parser.registerTag('ul', UnOrderedListTag);
parser.registerTag('h2', Heading2Tag);
parser.registerTag('h3', Heading3Tag);
parser.registerTag('h4', Heading4Tag);
parser.registerTag('pagenode', InternalLinkTag);
parser.registerTag('href', ExternalLinkTag);
parser.registerTag('file', DownloadButtonTag);
parser.registerTag('secundairebutton', SecondaryButtonTag);
parser.registerTag('primarybutton', PrimaryButtonTag);
parser.registerTag('youtube', YouTubeTag);
parser.registerTag('vimeo', VimeoTag);
parser.registerTag('action', CloseModal);